import Api from "./Api";
import Notifications from "./Notifications";

class UserService {
    filteredUsers = [];
    selected = null;
    current = null;
    callbacks = [];
    filters = this.defaultFilters();

    fetchFilteredUsers = async () => {
        return Api.fetch(this.uri());
    }

    defaultFilters() {
        return {
            search: "",
            active: false,
            admin: false,
            custAdmin: false,
            standard: false,
            standardNoOrdering: false,
            salesRep: false,
            sort: "lastName",
            persona: "*",
            storefrontNumber:""
        }
    }

    resetFilters() {
        this.filters = this.defaultFilters();
    }

    load = res => {
        if (res) {
            this.filteredUsers = res;
            this.updateSelectedUser();
            this.updateSubscribers();
        }
    }
    
    async add(user, customer = null) {
        let url = '/api/user';
        return Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({ user: user, customer: customer })
        }).then(this.handleResponse);
    }
    setCurrent = (user) => {
        this.current = user;
    }

    setUserLanguage = (id, language) => {
        return Api.fetch(`/api/user/setLanguage/${id}/${language}`, { method: 'POST' });
    }

    handleAddResponse = (res) => {
        if (res) {
            return this.fetchFilteredUsers();
        }
        Notifications.error("User already exists");
    }

    confirm(callback) {
        Notifications.confirmation("Would you like to continue?", callback);
    }

    getPersonas = () => {
        return Api.fetch("api/user/personas");
    }

    updateFilter(property, value) {
        this.filters[property] = value;
    }

    updateSelectedUser = () => {
        if (this.selected)
            for (let i = 0; i < this.filteredUsers.length; i++) {
                if (this.filteredUsers[i].id === this.selected.id) {
                    return this.setSelected(this.filteredUsers[i]);
                }
            }
    }

    getUserByid(id) {
        return Api.fetch(`/api/User/${id}`);
    }

    updateActive(id, callback) {
        this.confirm(() => this.updateActiveApi(id, callback));
    }
    getAvailableSalesTerritories(userId, salesTerritoryInput, callback) {
        Api.fetch(`/api/Customer/GetSalesTerritory/${userId}/${salesTerritoryInput}`).then(callback);
    }
    getUserSalesTerritories(userId, callback) {
        Api.fetch(`/api/user/${userId}/GetUserSalesTerritories`).then(callback);
    }
    getUserBusinessUnits(userId, callback) {
        Api.fetch(`/api/user/${userId}/GetUserBusinessUnits`).then(callback);
    }
    updateSalesTerritory(salesTerritoryCode, userId, callback) {
        Api.fetch(`/api/user/${userId}/UpdateSalesTerritory/${salesTerritoryCode}`, { method: 'POST' }).then(callback);
    }
    removeSalesTerritory(salesTerritoryCode, userId, callback) {
        Api.fetch(`/api/user/${userId}/RemoveSalesTerritoryForUser/${salesTerritoryCode}`, { method: 'POST' }).then(callback);
    }
    updateActiveApi(id, callback) {
        Api.fetch(`api/user/toggleActive/${id}`, { method: 'PUT' })
            .then(res => (res === null) && this.fetchFilteredUsers()).then(callback);
    }

    updateWarrantyAccess(id, roles, callback) {
        this.confirm(() => {
            this.updateWarrantyAccessApi(id, roles).then((res) => {
                if (callback)
                    callback();
            });
        });
    }

    updateAssignedBranches(id, branches) {
        let url = `/api/user/updateAssignedBranches`;
        return Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({userId: id, branches : branches})
        }).then(this.handleResponse);      
    }

    updateDashboardConfiguration(type, order ) {
        let url = `/api/user/updateDashboardConfiguration`;
        return Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({ type: type, order: order })
        }).then(this.handleRespons);
    }

    getDashboardConfiguration = () => { 
        return Api.fetch(`/api/dashboard/getDashboardConfiguration`, { method: 'POST'})
            .then((res) => {
                if (res)
                    return res.json();
            });
    }

    updateWarrantyAccessApi(id, roles) {
        return Api.fetch(`api/user/updateWarrantyAccess/${id}/${roles}`, { method: 'PUT' });
    }

    async mergeCustomersFromCSV(customerIds, userIds, addOnly, storefrontNumber) {
        let url = '/api/user/mergeFromCSV';
        return Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({ customerIds: customerIds, userIds: userIds, addOnly: addOnly, storefrontNumber: storefrontNumber })
        }).then(this.handleResponse);
    }

    async cloneUser(userId, updateUsersToClone, isRoleClone, callback) {
        let url = '/api/user/clone';
        return Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({ userId: userId, updateUsersToClone: updateUsersToClone, isRoleClone: isRoleClone })
        }).then(this.handleResponse);
    }

    updateStorefront(email, value) {
        this.confirm(() => this.updateStorefrontApi(email, value));
    }

    updateStorefrontApi(email, value) {
        email = email.replace('+', '%20');
        Api.fetch(`/api/user/${email}/storefront/${value}`, { method: 'PUT' });
    }

    async updatePersonaApi(userId, personaId) {
        Api.fetch(`/api/user/${userId}/setPersona/${personaId}`, { method: 'POST' })
            .then((res) => this.fetchFilteredUsers());
    }

    setSecondaryEmailApi(userId, secondaryEmail) {
        Api.fetch(`/api/user/setUserSecondaryEmail/${userId}/${secondaryEmail}`, { method: 'POST' }).then((res) => {
        });
    }

    getReports(callback) {
        Api.fetch(`/api/user/Reports`).then(callback);
    }

    getCustomers(userId, callback) {
        Api.fetch(`api/user/${userId}/customers`).then(callback);
    }

    setSelected(user) {
        this.selected = user;
        this.updateSubscribers();
    }

    subscribe(callback) {
        this.callbacks.push(callback);
    }

    updateSubscribers() {
        this.callbacks.forEach(cb => cb());
    }

    uri() {
        let clauses = [this.top(), this.skip(), this.orderBy()];
        clauses.push(this.filtersQuery(this.filters.active, this.filters.persona, this.filters.search, this.filters.storefrontNumber));
        return [`/api/user/list`, clauses.filter(c => !!c).join("&")].join("?");
    }

    top() { return "top=5000" }

    skip() { return "skip=0" }

    orderBy() { return `orderBy=${this.filters.sort}`; }

    filtersQuery(active, personas, search, storefrontNumber) {
        let filters = [];

        if (active)
            filters.push(`isActive=true`);

        if (personas && personas.length > 0) {
            let personaFilters = []

            for (var i = 0; i < personas.length; i++)
                personaFilters.push(`${personas[i]}`)

            filters.push(`personas=${personaFilters.join(",")}`);
        }

        if (storefrontNumber)
            filters.push(`storefrontNumber=${storefrontNumber}`)

        if (search)
            filters.push(`search=${search.trim()}`)

        if (filters.length) {
            return filters.join("&");
        }
        return "";
    }

    updateSelectedCustomer = async (customerId) => {
        return Api.fetch(`/api/user/updateSelectedCustomer/${customerId}`, { method: "PUT" });
    }

    setSecondaryEmailApi(userId, secondaryEmail) {
        Api.fetch(`/api/user/setUserSecondaryEmail/${userId}/${secondaryEmail}`, { method: 'POST' }).then((res) => {
        });
    }

    updateFullName = async (payload, localized) => {
        try {
            const response = await Api.post("api/user/updateFullName", payload);

            const responseData = await response.json();

            if (response.status === 400) {
                console.error("Validation errors:", responseData.Errors);
                Notifications.error(localized.ErrorUpdatingName);

                return responseData;
            }

            if (response.status === 401) {
                console.warn("Unauthorized:", responseData);
                Notifications.error(localized.UnauthorizedUpdateName);

                return responseData;
            }

            if (response.status >= 500) {
                console.error("Server error occurred:", responseData);
                Notifications.error(localized.ErrorUpdatingName);

                return responseData;
            }

            if (response.ok) {
                Notifications.message(localized.NameUpdatedSucess);

                return responseData;
            }

            console.error("Unexpected error:", responseData);
            Notifications.error(localized.ErrorUpdatingName);

            return responseData;

        } catch (error) {
            console.error("Update Full Name Error:", error);
            Notifications.error(localized.UnexpectedNameUpdateError);

            return { isSuccess: false, isUnauthorized: false };
        }
    };
    handleResponse = (response) => {
        if (response) {
            return response.json();
        }
    }
    async addUserFavorite(userId, productId) {
        let url = '/api/user/CreateUserFavorites';        
        return await Api.fetch(url, {
            method: 'POST',
            body: JSON.stringify({ UserId: userId, ProductId: productId })
        }).then(this.handleResponse);
    }
    async removeUserFavorite(productId) {
        return await Api.fetch(`/api/user/DeleteUserFavorites/${productId}`, { method: 'POST' }).then(this.handleResponse);
    }    
    getUserFavoriteList = () => {
        return Api.fetch("api/user/GetFavoritesListByUser");
    }
    async removeUserFavoriteList() {
        return await Api.fetch(`/api/user/DeleteFavorites`, { method: 'DELETE' }).then(this.handleResponse);
    }  
    async saveFiltersAsync(invoice, orders, quotes) {
        const url = '/api/user/updateFiltersAsync';
        const bodyload = { filtersJson: { invoice, orders, quotes } };

        return await Api.fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bodyload)
        });
    }

}

export default new UserService();
